export const ONBOARDING_PANEL_ID = 'onboarding-panel';

export const CURRENT_TAB_ID = 'onboarding-current';
